import type { ResolvedGoOfflineConfig, RuntimeMessagePayload } from "../types";

export function serializeRuntimeConfig(config: ResolvedGoOfflineConfig): RuntimeMessagePayload {
  return {
    type: "GO_OFFLINE_CONFIG",
    config: {
      version: config.version,
      offlinePage: config.offlinePage,
      offlineImage: config.offlineImage,
      precache: config.precache,
      runtimeCaching: config.runtimeCaching,
      debug: config.debug
    }
  };
}
